export const environment = {
  messagingServiceBaseUrl: 'https://development.customer-api.deliverysolutions.co/api/v2/messaging',
  production: false,
};
